import { ExtraOptionsKeys, MethodOfEnergyGeneration, PowerRequirements } from "./index250.js";
import { defaultTechPresetValues } from "./index251.js";
import { TechSpacePresetTranslatorRulesLib } from "./index252.js";
import { techSpacePreset2Props } from "./index253.js";
function techSpaceProps2Preset({ forceInvalid = false, userDefinedAttributes = {}, optionalSpaces = [] }) {
	const options = [];
	for (const key in TechSpacePresetTranslatorRulesLib) {
		const option = TechSpacePresetTranslatorRulesLib[key];
		if (checkOption(option, forceInvalid, userDefinedAttributes, optionalSpaces)) options.push(key);
	}
	const output = structuredClone(defaultTechPresetValues);
	for (const key in output.extraOptions) output.extraOptions[key] = false;
	for (const option of options) if (Object.values(MethodOfEnergyGeneration).includes(option)) output.energyGeneration = option;
	else if (Object.values(PowerRequirements).includes(option)) output.powerRequirements = option;
	else if (Object.values(ExtraOptionsKeys).includes(option)) output.extraOptions[option] = true;
	if (!testOutput(output, {
		forceInvalid,
		userDefinedAttributes,
		optionalSpaces
	})) throw new Error("Translation failed, incoming AggTechSpacesProps object cannot be directly matched to preset.");
	return output;
}
function checkOption(option, forceInvalid, attributes, optionalSpaces) {
	if (option.forceInvalid !== forceInvalid) return false;
	if (option.userDefinedAttributes) {
		for (const attribute in option.userDefinedAttributes) if (attributes[attribute] !== option.userDefinedAttributes[attribute]) return false;
	}
	if (option.optionalSpaces) {
		for (const space of option.optionalSpaces) if (!optionalSpaces.some((s) => s.name === space.name)) return false;
	}
	return true;
}
function testOutput(output, input) {
	const testObj = techSpacePreset2Props(output);
	if (testObj.forceInvalid !== input.forceInvalid) return false;
	for (const attribute of Object.keys(testObj.userDefinedAttributes)) if (input.userDefinedAttributes[attribute] !== testObj.userDefinedAttributes[attribute]) return false;
	for (const space of testObj.optionalSpaces) if (!input.optionalSpaces.some((s) => s.name === space.name)) return false;
	return true;
}
export { techSpaceProps2Preset };

//# sourceMappingURL=index254.js.map